import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-md mb-4 flex justify-between items-center font-bold text-gray-900" }
const _hoisted_2 = { class: "font-bold text-gray-900" }
const _hoisted_3 = { class: "text-sm text-gray-iron-700" }
const _hoisted_4 = { class: "font-bold text-gray-900" }
const _hoisted_5 = { class: "text-sm text-gray-iron-700" }

import { computed } from 'vue';
import { useRoute } from 'vue-router';

import Card from 'primevue/card';

import ColoredText from '@/components/ColoredText.vue';
import { useEstimatedSegments } from '@/composables/useEstimatedSegments';
import { useVisibleCalculationItems } from '@/composables/useVisibleCalculationItems';
import DefaultChip from '../components/DefaultChip.vue';
import CalculationItemsVisibilityButton from '../components/CalculationItemsVisibilityButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationItemsPreview',
  setup(__props) {

const { hiddenFilter } = useVisibleCalculationItems();

const reactiveFilters = computed(() => ({
  hidden: hiddenFilter.value,
  includeChildRules: false,
  ruleTypes: ['calculation'],
  includeSegmentRules: true,
  includeGroupRules: true,
}));

const { segmentRules } = useEstimatedSegments(reactiveFilters);

const route = useRoute();

const currentSegmentRules = computed(() => {
  return segmentRules.value?.filter(
    (segment) => segment.id === Number(route.params.segmentId) && segment.rules.length
  );
});

const currentSegmentGroupRules = computed(() => {
  return currentSegmentRules.value?.map((segment) => {
    return {
      ...segment,
      groups: segment.groups.filter(
        (group) => group.id === Number(route.params.groupId) && group.rules.length
      ),
    };
  });
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (currentSegmentRules.value?.length)
    ? (_openBlock(), _createBlock(_unref(Card), {
        key: 0,
        class: "border border-gray-200 !shadow-none"
      }, {
        content: _withCtx(() => [
          _createElementVNode("header", _hoisted_1, [
            _cache[0] || (_cache[0] = _createElementVNode("span", null, "Podsumowanie obliczeń", -1)),
            _createVNode(CalculationItemsVisibilityButton)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentSegmentGroupRules.value, (segment) => {
            return (_openBlock(), _createElementBlock("div", {
              key: segment.id,
              class: "space-y-1"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segment.groups, (group) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: group.id,
                  class: "space-y-1"
                }, [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(group.name), 1),
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.rules, (groupRule) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: groupRule.id,
                        class: "flex items-center justify-between py-3.5"
                      }, [
                        _createVNode(ColoredText, {
                          variant: groupRule.color,
                          class: "max-w-40 text-sm"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(groupRule.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["variant"]),
                        _withDirectives((_openBlock(), _createBlock(DefaultChip, {
                          class: "max-w-80 overflow-x-auto",
                          variant: groupRule.color
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(groupRule.eval) + " " + _toDisplayString(groupRule.unit), 1)
                          ]),
                          _: 2
                        }, 1032, ["variant"])), [
                          [
                            _directive_tooltip,
                            groupRule.expression,
                            void 0,
                            { top: true }
                          ]
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_4, "Podsumowanie " + _toDisplayString(segment.name), 1),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segment.rules, (rule) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: rule.id,
                    class: "flex items-center justify-between py-3.5"
                  }, [
                    _createVNode(ColoredText, {
                      variant: rule.color,
                      class: "max-w-40 text-sm"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(rule.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["variant"]),
                    _withDirectives((_openBlock(), _createBlock(DefaultChip, {
                      class: "max-w-80 overflow-x-auto",
                      variant: rule.color
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(rule.eval) + " " + _toDisplayString(rule.unit), 1)
                      ]),
                      _: 2
                    }, 1032, ["variant"])), [
                      [
                        _directive_tooltip,
                        rule.expression,
                        void 0,
                        { top: true }
                      ]
                    ])
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})